<mat-card class="max-w-[600px] justify-center self-center">
    <mat-card-header class="mb-2 flex items-center">
        <mat-icon fontIcon="error" class="text-red-600!" mat-card-avatar></mat-icon>

        <mat-card-title>{{ (this.errorInfoObs | async)?.title || 'Fehler beim Laden der Ixserv-Konfig' }}</mat-card-title>
    </mat-card-header>

    <mat-card-content class="mb-4">
        @if ((this.errorInfoObs | async)?.paragraphs; as paragraphs) {
            @for (paragraph of paragraphs; track $index) {
                <p class="mb-2">{{ paragraph }}</p>
            }
        } @else {
            @if (!logoutUrl) {
                <p class="mb-2">
                    Es ist ein Fehler beim Laden der Ixserv-Konfig aufgetreten. Sollte der Fehler auch nach Neuladen der Seite bestehen
                    bleiben, kontaktieren Sie bitte Ihren Administrator.
                </p>
            } @else {
                Der Benutzer konnte dem ix.serv nicht zugeordnet werden. Bitte melden sie sich mit einem für dieses ix.serv-System gültigen
                Benutzer an.
            }
        }

        <div class="mt-4">
            @if (!logoutUrl) {
                <button
                    mat-stroked-button
                    color="primary"
                    (click)="this.redirectToProvidedUrl()"
                    [disabled]="!(this.isRedirectCooledDownObs | async)"
                >
                    Erneut versuchen
                </button>
            } @else {
                <button mat-stroked-button color="primary" (click)="this.logoutAndRedirect()" [disabled]="!(this.logoutUrlObs | async)">
                    Mit anderem Benutzer anmelden
                </button>
            }
        </div>
    </mat-card-content>

    <mat-card-footer>
        <mat-progress-bar
            [ngClass]="{ invisible: this.isRedirectCooledDownObs | async }"
            mode="determinate"
            [value]="this.redirectTimerObs | async"
        ></mat-progress-bar>
    </mat-card-footer>
</mat-card>
